<template>
  <div
    class="row no-wrap bg-white footer-bar items-center border"
  >
    <div class="col border-right text-center">
      <span class="label-key">Logado</span>
      <span class="footer-values">
        <TimerSeconds
          class="label-value"
          :value="agent.summary.loginSecs"
        />
      </span>
    </div>

    <div class="col border-right text-center attendances-cell">
      <span class="label-key">{{ totalAttendances === 1 ? 'Atendimento' : 'Atendimentos' }}</span>
      <span class="footer-values">
        <span class="label-value font-weight-500">{{ `( ${totalAttendances} )` || '-' }}</span>
        <TimerSeconds
          class="label-value"
          v-if="agent.inAttendance"
          :value="agent.summary.callSecs"
        />
        <TimerLabel
          class="label-value"
          v-else
          :seconds="agent.summary.callSecs"
        />
      </span>
    </div>

    <div class="col border-right text-center">
      <span class="label-key">Pausa</span>
      <span class="footer-values">
        <TimerSeconds
          v-if="agent.paused"
          :value="agent.summary.pauseSecs"
          class="label-value"
        />
        <TimerLabel
          v-else
          :seconds="agent.summary.pauseSecs"
          class="label-value"
        />
      </span>
    </div>

    <div class="col border-right text-center">
      <span class="label-key">TMO R</span>
      <span class="footer-values">
        <TimerLabel
          class="label-value"
          :seconds="averageReceptiveOperation"
        />
      </span>
    </div>

    <div class="col text-center">
      <span class="label-key">TMO A</span>
      <span class="footer-values">
        <TimerLabel
          class="label-value"
          :seconds="averageActiveOperation"
        />
      </span>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import TimerLabel from '@/components/TimerLabel'
import TimerSeconds from '@/components/TimerSeconds'
import { DIRECTION_OUT } from '@/constants/directions'

export default {
  components: {
    TimerLabel,
    TimerSeconds
  },

  data () {
    return {
      window: {}
    }
  },

  computed: {
    ...mapState({
      current: (state) => state.attendanceModule.current,
      attendanceHistory: (state) => state.attendanceModule.history,
      agent: (state) => state.agentModule.session.agent,
      loading: (state) => state.agentModule.session.loading,
      agentModule: (state) => state.agentModule
    }),

    totalAttendances () {
      return Object.keys(this.attendanceHistory).length
    },

    averageActiveOperation () {
      return this.calculateAverageOperation((a) => a.direction === DIRECTION_OUT && a.hangupAt)
    },

    averageReceptiveOperation () {
      return this.calculateAverageOperation((a) => a.direction !== DIRECTION_OUT && a.hangupAt)
    }
  },

  methods: {
    calculateAverageOperation (filter) {
      const values = Object.values(this.attendanceHistory)
        .filter(filter)
      const total = values.reduce((a, b) => {
        return a + (b.hangupAt - b.createdAt)
      }, 0) / values.length

      return (total / 1000) || 0
    }
  }
}
</script>

<style lang="sass" scoped>
.label-value
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 15px
  color: #01253C

.label-key
  font-style: normal
  font-weight: normal
  font-size: 12px
  line-height: 14px
  color: #01253C
  opacity: 0.6

.border-right
  border-right: 1px solid #CDDCE5

.border
  border: 1px solid #CDDCE5

.footer-bar
  height: 32px
  min-width: 430px

  > div
    min-width: 0
    white-space: nowrap
    overflow: hidden

  > div.attendances-cell
    min-width: 200px

.label-key:after
  content: ': '

.footer-values > * + *
  margin-left: 4px

// Abaixo desta largura os cinco rótulos não caberiam em linha: valor sobe,
// rótulo desce em versão compacta (mesma linguagem dos tiles do topo).
@media (max-width: 620px)
  .footer-bar
    > div
      display: flex
      flex-direction: column-reverse
      align-items: center
      justify-content: center
      line-height: 1.15

    > div.attendances-cell
      min-width: 0

  .label-key
    font-size: 9px
    text-transform: uppercase
    letter-spacing: 0.03em

    &:after
      content: ''

.font-weight-500
  font-weight: 500
</style>
